import { defineMessages } from 'react-intl'

export interface Message {
  id: string
  defaultMessage: string
}

export const messages = defineMessages({
  CUSTOMER_NUMBER: { id: 'CUSTOMER_NUMBER', defaultMessage: 'Customer Number' },
  PREVIOUS_NUMBER: { id: 'PREVIOUS_NUMBER', defaultMessage: 'Order Number' },
  QUOTE_REFERENCE: { id: 'QUOTE_REFERENCE', defaultMessage: 'Quote Reference' },
  CUSTOMER_PIN: { id: 'CUSTOMER_PIN', defaultMessage: 'Pin Number' },
  PACKING_SLIP_NUMBER: {
    id: 'PACKING_SLIP_NUMBER',
    defaultMessage: 'Packing Slip Number',
  },
  FIELD_REQUIRED_NAME: {
    id: 'FIELD_REQUIRED_NAME',
    defaultMessage: 'Field Required',
  },
  FIELD_REQUIRED_COUNT: {
    id: 'FIELD_REQUIRED_COUNT',
    defaultMessage: 'There are {numErrors} errors on the page',
  },
  EMOJI_NOT_SUPPORTED: {
    id: 'EMOJI_NOT_SUPPORTED',
    defaultMessage: ' Emojis are not supported',
  },
  TRANSACTIONAL_INFORMATION: {
    id: 'TRANSACTIONAL_INFORMATION',
    defaultMessage: 'Transactional Information',
  },
  SUBMIT: { id: 'SUBMIT', defaultMessage: 'Submit' },
  LINK_ORGANIZATION: {
    id: 'LINK_ORGANIZATION',
    defaultMessage: 'Connect Your Account',
  },
  ILL_DO_THIS_LATER: {
    id: 'ILL_DO_THIS_LATER',
    defaultMessage: "I'll Do This Later",
  },
  CONTINUE_BROWSING: {
    id: 'CONTINUE_BROWSING',
    defaultMessage: 'Continue Browsing',
  },
  LINK_PROFILE_DIALOG_TITLE: {
    id: 'LINK_PROFILE_DIALOG_TITLE',
    defaultMessage: 'Are You Sure?',
  },
  LINK_PROFILE_DIALOG_TEXT: {
    id: 'LINK_PROFILE_DIALOG_TEXT',
    defaultMessage:
      'Are you sure you want to link your account later? To order products, view contract pricing, or request quotes, a profile must be linked to a registered organization. You may also register a new organization.',
  },
  LINK_PROFILE_DIALOG_REGISTER_ORGANIZATION: {
    id: 'LINK_PROFILE_DIALOG_REGISTER_ORGANIZATION',
    defaultMessage: 'Register Organization',
  },
  LINK_PROFILE_DIALOG_TRY_AGAIN: {
    id: 'LINK_PROFILE_DIALOG_TRY_AGAIN',
    defaultMessage: 'Try Again',
  },
  LINK_PROFILE_DIALOG_ILL_DO_THIS_LATER: {
    id: 'LINK_PROFILE_DIALOG_ILL_DO_THIS_LATER',
    defaultMessage: "I'll Do This Later",
  },
  LINK_PROFILE_ACCOUNT_INFO_MODAL_TITLE: {
    id: 'LINK_PROFILE_ACCOUNT_INFO_MODAL_TITLE',
    defaultMessage: 'Account info & Transactional info',
  },
  LINK_PROFILE_ACCOUNT_INFO_MODAL_CONTENT: {
    id: 'LINK_PROFILE_ACCOUNT_INFO_MODAL_CONTENT',
    defaultMessage:
      'Please use the invoice example to find your account information and transactional information.',
  },
  ACCOUNT_INFORMATION: {
    id: 'ACCOUNT_INFORMATION',
    defaultMessage: 'Account Information',
  },
  LINK_OR_REGISTER_PROFILE_HEADING: {
    id: 'LINK_OR_REGISTER_PROFILE_HEADING',
    defaultMessage: 'Connect to Your Organization',
  },
  LINK_OR_REGISTER_PROFILE_HEADING_SELF: {
    id: 'LINK_OR_REGISTER_PROFILE_HEADING_SELF',
    defaultMessage: 'Self Affiliate',
  },
  LINK_OR_REGISTER_PROFILE_DESCRIPTION: {
    id: 'LINK_OR_REGISTER_PROFILE_DESCRIPTION',
    defaultMessage:
      'Linking your account to your organization enables you to place orders and unlocks other benefits.',
  },
  LINK_OR_REGISTER_PROFILE_DESCRIPTION_SELF: {
    id: 'LINK_OR_REGISTER_PROFILE_DESCRIPTION_SELF',
    defaultMessage:
      'To immediately access contract pricing or place orders and quotes, you must affiliate with your organization information.',
  },
  REQUIRED_FIELDS: { id: 'REQUIRED_FIELDS', defaultMessage: 'Required Fields' },
  ORG_ORDERED_IN_PAST: {
    id: 'ORG_ORDERED_IN_PAST',
    defaultMessage: 'Has your organization ordered from us before?',
  },
  LINK_PROFILE_COMPLETE_PROCESSS: {
    id: 'LINK_PROFILE_COMPLETE_PROCESSS',
    defaultMessage:
      'If so, connecting to your organization is simple. Just enter a <b>customer number</b> along with a corresponding <b>transaction number</b>.',
  },
  LINK_PROFILE_COMPLETE_PROCESS_HINT: {
    id: 'LINK_PROFILE_COMPLETE_PROCESS_HINT',
    defaultMessage:
      'How to enter Account Information & Transactional Information?',
  },
  OR: { id: 'OR', defaultMessage: 'or' },
  ORG_FIRST_TIME_ORDER: {
    id: 'ORG_FIRST_TIME_ORDER',
    defaultMessage: 'Not Sure? Continue Registration.',
  },
  ORG_FIRST_TIME_ORDER_INFO: {
    id: 'ORG_FIRST_TIME_ORDER_INFO',
    defaultMessage:
      'Please have the following information about your organization ready:',
  },
  ORG_FIRST_TIME_ORDER_EMERALD: {
    id: 'ORG_FIRST_TIME_ORDER_EMERALD',
    defaultMessage: 'Register to Purchase Merck Chemicals Products',
  },
  REGISTER_TO_PURCHASE_PRODUCTS: {
    id: 'REGISTER_TO_PURCHASE_PRODUCTS',
    defaultMessage: 'Register to Purchase {companyName} Products',
  },
  ORG_FIRST_TIME_ORDER_INFO1_EMERALD: {
    id: 'ORG_FIRST_TIME_ORDER_INFO1_EMERALD',
    defaultMessage:
      'One or more products in your cart require secondary registration in order to purchase them.',
  },
  ORG_FIRST_TIME_ORDER_INFO2_EMERALD: {
    id: 'ORG_FIRST_TIME_ORDER_INFO2_EMERALD',
    defaultMessage: 'Continue registration and we will look up your details.',
  },
  ORG_FIRST_TIME_ORDER_INFO3_EMERALD: {
    id: 'ORG_FIRST_TIME_ORDER_INFO3_EMERALD',
    defaultMessage: 'Please have the following information ready:',
  },
  ORG_FIRST_TIME_ORDER_INFO4_EMERALD: {
    id: 'ORG_FIRST_TIME_ORDER_INFO4_EMERALD',
    defaultMessage:
      'For academia, government, and hospital customers, please contact your sales representative {br} or call our hotline: 4006203333-1 before continuing registration.',
  },
  LINK_PROFILE_SHIPPING_BILLING_PAYMENT_ADDRESSES: {
    id: 'LINK_PROFILE_SHIPPING_BILLING_PAYMENT_ADDRESSES',
    defaultMessage: 'Shipping, billing & payment addresses',
  },
  LINK_PROFILE_ORGANIZATION_HEADQUARTERS_ADDRESS: {
    id: 'LINK_PROFILE_ORGANIZATION_HEADQUARTERS_ADDRESS',
    defaultMessage: 'The address of your organization’s registered office',
  },
  LINK_PROFILE_PRIMARY_BUSINESS_ACTIVITY: {
    id: 'LINK_PROFILE_PRIMARY_BUSINESS_ACTIVITY',
    defaultMessage: 'Primary business activities',
  },
  LINK_PROFILE_VAT_SALES_EXEMPTION_STATUS: {
    id: 'LINK_PROFILE_VAT_SALES_EXEMPTION_STATUS',
    defaultMessage: 'VAT and sales tax exemption status',
  },
  LINK_PROFILE_COMPLETE_REGISTRATION: {
    id: 'LINK_PROFILE_COMPLETE_REGISTRATION',
    defaultMessage: 'Complete Registration',
  },
  CUSTOMER_NUMBER_PRP_DEFINITION: {
    id: 'CUSTOMER_NUMBER_PRP_NUMBER_DEFINITION',
    defaultMessage:
      'Your customer number is typically ten digits starting with a 2 and can be found in the upper portion of an order confirmation, quote or invoice.',
  },
  TRANSACTION_ORDER_PRP_NUMBER_DEFINITION: {
    id: 'TRANSACTION_ORDER_PRP_NUMBER_DEFINITION',
    defaultMessage:
      'Order Number is typically ten digits starting with a 3 and can be found in the upper portion of an order confirmation or invoice but may also be called the internal order number or sales order number.',
  },
  TRANSACTION_QUOTE_PRP_NUMBER_DEFINITION: {
    id: 'TRANSACTION_QUOTE_PRP_NUMBER_DEFINITION',
    defaultMessage:
      'If you received a quote from a sales representative, the quote reference is typically eleven characters and begins with an R. If you received it directly from our customer service or a colleague who created it online, the quote reference is typically ten digits starting with 20.',
  },
  TRANSACTION_INVOICE_PRP_NUMBER_DEFINITION: {
    id: 'TRANSACTION_INVOICE_PRP_NUMBER_DEFINITION',
    defaultMessage:
      'Invoice Number is typically eight digits starting with 8 and is only shown on the invoice document.',
  },
  CUSTOMER_NUMBER_PRD_DEFINITION: {
    id: 'CUSTOMER_NUMBER_PRD_NUMBER_DEFINITION',
    defaultMessage:
      'Your customer number is typically eight digits starting with a 4 or 5 and can be found in the upper portion of an order confirmation, quote or invoice.',
  },
  TRANSACTION_ORDER_PRD_NUMBER_DEFINITION: {
    id: 'TRANSACTION_ORDER_PRD_NUMBER_DEFINITION',
    defaultMessage:
      'Order number is typically ten digits starting with a 3 and can be found in the upper portion of an order confirmation or invoice but may also be called the internal order number or sales order number.',
  },
  TRANSACTION_QUOTE_PRD_NUMBER_DEFINITION: {
    id: 'TRANSACTION_QUOTE_PRD_NUMBER_DEFINITION',
    defaultMessage:
      'If you received a quote from a sales representative, the quote reference is typically eleven characters and begins with an R. If you received it directly from our customer service or a colleague who created it online, the quote reference is typically eight digits starting with 22.',
  },
  TRANSACTION_INVOICE_PRD_NUMBER_DEFINITION: {
    id: 'TRANSACTION_INVOICE_PRD_NUMBER_DEFINITION',
    defaultMessage:
      'Invoice number is typically nine digits starting with 55 and is only shown on the invoice document.',
  },
  CUSTOMER_NUMBER_PRE_DEFINITION: {
    id: 'CUSTOMER_NUMBER_PRE_NUMBER_DEFINITION',
    defaultMessage:
      'Your customer number is typically eight digits and can be found in the upper portion of an order confirmation, quote or invoice.',
  },
  TRANSACTION_ORDER_PRE_NUMBER_DEFINITION: {
    id: 'TRANSACTION_ORDER_PRE_NUMBER_DEFINITION',
    defaultMessage:
      'Order number is typically ten digits starting with an 8 and can be found in the upper portion of an order confirmation or invoice.',
  },
  TRANSACTION_QUOTE_PRE_NUMBER_DEFINITION: {
    id: 'TRANSACTION_QUOTE_PRE_NUMBER_DEFINITION',
    defaultMessage:
      'If you received a quote from a sales representative, the quote reference is typically eleven characters and begins with an R. If you received it directly from our customer service or a colleague who created it online, the quote reference is typically ten digits starting with 82.',
  },
  TRANSACTION_INVOICE_PRE_NUMBER_DEFINITION: {
    id: 'TRANSACTION_INVOICE_PRE_NUMBER_DEFINITION',
    defaultMessage:
      'Invoice number is typically ten digits starting with 80 and is only shown on the invoice document.',
  },
  CUSTOMER_CONFIRMATION_DIALOG_TITLE: {
    id: 'CUSTOMER_CONFIRMATION_DIALOG_TITLE',
    defaultMessage: 'customer number',
  },
  TRANSACTION_CONFIRMATION_DIALOG_TITLE: {
    id: 'TRANSACTION_CONFIRMATION_DIALOG_TITLE',
    defaultMessage: 'Transaction Information',
  },
  LINK_OR_REGISTER_PROFILE_HEADING_CONNECT_ORG: {
    id: 'LINK_OR_REGISTER_PROFILE_HEADING_CONNECT_ORG',
    defaultMessage: 'Connect to Your Organization',
  },
  LINK_OR_REGISTER_PROFILE_DESCRIPTION_LINK_ACCOUNT_BENEFITS: {
    id: 'LINK_OR_REGISTER_PROFILE_DESCRIPTION_LINK_ACCOUNT_BENEFITS',
    defaultMessage:
      'Linking your account to your organization enables you to place orders and unlocks other benefits.',
  },
  LINK_PROFILE_COMPLETE_PROCESS_SUBTITLE: {
    id: 'LINK_PROFILE_COMPLETE_PROCESS_SUBTITLE',
    defaultMessage:
      'If so, connecting to your organization is simple. Just enter a {customerNumber} along with a corresponding {transactionNumber}.',
  },
  TRANSACTION_NUMBER: {
    id: 'TRANSACTION_NUMBER',
    defaultMessage: 'Transaction  Number',
  },
  FIND_YOUR_CUSTOMER_NUMBER: {
    id: 'FIND_YOUR_CUSTOMER_NUMBER',
    defaultMessage: 'Find Your Customer Number',
  },
  FIND_YOUR_CUSTOMER_NUMBER_DESC: {
    id: 'FIND_YOUR_CUSTOMER_NUMBER_DESC',
    defaultMessage:
      'Your customer number is typically eight digits starting with a 4 or 5 and can be found in the upper portion of an order confirmation, quote, or invoice.',
  },
  ORDER_CONFIRMATION: {
    id: 'ORDER_CONFIRMATION',
    defaultMessage: 'Order Confirmation',
  },
  OKAY: {
    id: 'OKAY',
    defaultMessage: 'Okay',
  },
  FIND_YOUR_TRANSACTION_NUMBER: {
    id: 'FIND_YOUR_TRANSACTION_NUMBER',
    defaultMessage: 'Find Your Transaction Number',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC',
    defaultMessage:
      '{orderNumber}: Your sales order number is typically ten digits starting with a 3 and can be found in the upper portion of a confirmation or invoice.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC',
    defaultMessage:
      '{quoteReference}: Your quote number is typically eight digits starting with a 2 and can be found in the upper portion of a quote. Note: Quotes starting with an “R-“ cannot be used to affiliate your account.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC',
    defaultMessage:
      '{invoiceNumber}: Your invoice number is typically nine digits starting with a 56 and can be found in the upper portion of an invoice.',
  },
  TRANSACTION_NUMBER_SELECT_ONE: {
    id: 'TRANSACTION_NUMBER_SELECT_ONE',
    defaultMessage: 'Transaction  Number (select one)',
  },
  CONNECT_YOUR_ACCONT: {
    id: 'CONNECT_YOUR_ACCONT',
    defaultMessage: 'Connect Your Account',
  },
  ENTER: {
    id: 'ENTER',
    defaultMessage: 'Enter',
  },
  UNABLE_TO_FIND_PREVIOUS_TRANSACTION: {
    id: 'UNABLE_TO_FIND_PREVIOUS_TRANSACTION',
    defaultMessage: 'Unable to find a previous transaction?',
  },
  CONTINUE_REGISTRATION: {
    id: 'CONTINUE_REGISTRATION',
    defaultMessage: 'Continue registration',
  },
  CONNECT_ACCOUNT_BENEFITS: {
    id: 'CONNECT_ACCOUNT_BENEFITS',
    defaultMessage: 'Connect your account to unlock these benefits:',
  },
  CONNECT_ACCOUNT_BENEFITS_1: {
    id: 'CONNECT_ACCOUNT_BENEFITS_1',
    defaultMessage: 'Order from our extensive inventory',
  },
  CONNECT_ACCOUNT_BENEFITS_2: {
    id: 'CONNECT_ACCOUNT_BENEFITS_2',
    defaultMessage: 'View exclusive pricing',
  },
  CONNECT_ACCOUNT_BENEFITS_3: {
    id: 'CONNECT_ACCOUNT_BENEFITS_3',
    defaultMessage:
      'Let team members skip registration with “Invite a Coworker”',
  },
  CONNECT_ACCOUNT_BENEFITS_4: {
    id: 'CONNECT_ACCOUNT_BENEFITS_4',
    defaultMessage: 'Track orders, create quotes, and view recent activity',
  },
  CONNECT_ACCOUNT_MOBILE_BENEFITS_1: {
    id: 'CONNECT_ACCOUNT_MOBILE_BENEFITS_1',
    defaultMessage: 'Place & track orders',
  },
  CONNECT_ACCOUNT_MOBILE_BENEFITS_2: {
    id: 'CONNECT_ACCOUNT_MOBILE_BENEFITS_2',
    defaultMessage: 'View exclusive pricing',
  },
  CONNECT_ACCOUNT_MOBILE_BENEFITS_3: {
    id: 'CONNECT_ACCOUNT_MOBILE_BENEFITS_3',
    defaultMessage: 'Create quotes & view recent activity',
  },
  CONNECT_ACCOUNT_MOBILE_BENEFITS_4: {
    id: 'CONNECT_ACCOUNT_MOBILE_BENEFITS_4',
    defaultMessage:
      'Let team members skip registration with “Invite a Coworker”',
  },
  CONNECT_ACCOUNT_BENEFITS_FULL_REGISTRATION: {
    id: 'CONNECT_ACCOUNT_BENEFITS_FULL_REGISTRATION',
    defaultMessage: 'Connecting your account unlocks these benefits:',
  },
  FIND_YOUR_CUSTOMER_NUMBER_DESC_PRP: {
    id: 'FIND_YOUR_CUSTOMER_NUMBER_DESC_PRP',
    defaultMessage:
      'Your customer number is typically ten digits starting with a 2 and can be found in the upper portion of an order confirmation, quote, or invoice.',
  },
  FIND_YOUR_CUSTOMER_NUMBER_DESC_PRE: {
    id: 'FIND_YOUR_CUSTOMER_NUMBER_DESC_PRE',
    defaultMessage:
      'Your customer number is typically eight digits starting with a 1 or 3 and can be found in the upper portion of an order confirmation, quote, or invoice.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRP: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRP',
    defaultMessage:
      '{orderNumber}: Your sales order number is typically ten digits starting with a 3 and can be found in the upper portion of a confirmation or invoice.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRP: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRP',
    defaultMessage:
      '{quoteReference}: Your quote number is typically ten digits starting with a 2 and can be found in the upper portion of a quote. Note: Quotes starting with an “R-“ cannot be used to affiliate your account.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRP: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRP',
    defaultMessage:
      '{invoiceNumber}: Your invoice number is typically ten digits starting with a 67 and can be found in the upper portion of an invoice.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRE: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRE',
    defaultMessage:
      '{orderNumber}: Your sales order number is typically ten digits starting with an 8 and can be found in the upper portion of a confirmation or invoice.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRE: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRE',
    defaultMessage:
      '{quoteReference}: Your quote number is typically ten digits starting with an 8 or R- and can be found in the upper portion of a quote.',
  },
  LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRE: {
    id: 'LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRE',
    defaultMessage:
      '{invoiceNumber}: Your invoice number is typically ten digits starting with an 8 and can be found in the upper portion of an invoice.',
  },
  FIND_YOUR_ORDER_NUMBER: {
    id: 'FIND_YOUR_ORDER_NUMBER',
    defaultMessage: 'Find Your Order Number',
  },
  LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRE: {
    id: 'LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRE',
    defaultMessage:
      '{orderNumber}: Your order number is typically ten digits starting with an 8 and can be found in the upper portion of an {orderConfirmation} or {invoice}. It may also be called the internal order number or sales order number.',
  },
  LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRP: {
    id: 'LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRP',
    defaultMessage:
      '{orderNumber}: Your order number is typically ten digits starting with a 3 and can be found in the upper portion of an {orderConfirmation} or {invoice}. It may also be called the internal order number or sales order number.',
  },
  LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRD: {
    id: 'LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRD',
    defaultMessage:
      '{orderNumber}: Your order number is typically ten digits starting with a 3 and can be found in the upper portion of an {orderConfirmation} or {invoice}. It may also be called the internal order number or sales order number.',
  },
})

export default messages
